import { Box, Flex, Image, Text } from "@chakra-ui/react";

import imgContent01 from "../../../assets/images/content/bg/content-testops-01.png";
import imgContent02 from "../../../assets/images/content/bg/content-testops-02.png";
import imgContent03 from "../../../assets/images/content/bg/content-testops-03.png";
import tContent01 from "../../../assets/images/content/bg/content-tablet-testops-01.png";
import tContent02 from "../../../assets/images/content/bg/content-tablet-testops-02.png";
import tContent03 from "../../../assets/images/content/bg/content-tablet-testops-03.png";
import mContent01 from "../../../assets/images/content/bg/content-mobile-testops-01.png";
import mContent02 from "../../../assets/images/content/bg/content-mobile-testops-02.png";
import mContent03 from "../../../assets/images/content/bg/content-mobile-testops-03.png";
import item001 from "../../../assets/images/content/item/item-testops-001.png";
import item002 from "../../../assets/images/content/item/item-testops-002.png";
import mitem001 from "../../../assets/images/content/item/item-mobile-testops-001.png";
import mitem002 from "../../../assets/images/content/item/item-mobile-testops-002.png";



import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";
import { convertFontSize } from "../../../components/Util";


const TestOps = () => {
  const screen = useContext(ScreenContext).style;
  const contents = [
    {
      pc: imgContent01,
      mobile: mContent01,
      tablet: tContent01,
    },
    {
      pc: imgContent02,
      mobile: mContent02,
      tablet: tContent02,
    },
    {
      pc: imgContent03,
      mobile: mContent03,
      tablet: tContent03,
    },
  ];

  return (
    <Box w={"100%"} display={"flex"} flexDir={"column"} alignItems={"center"}>
      <Image 
        src={contents[0][screen]} 
        w={"100%"} 
        alt="" 
      />
      {screen !== "mobile" ?
        <Box 
          w={screen === "tablet" ? "90%" : "70%"} 
        >
          <Image 
            src={item001} 
            w={"100%"} 
            h={"auto"} 
            alt="" 
          />
        </Box>
      :
        <Box 
          display={"flex"} 
          w={"90%"} 
          h={"fit-content"}
          justifyContent={"start"} 
          overflowX={"scroll"}
          css={{
            '&::-webkit-scrollbar': {
              height: '10px'
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#A4A8AD',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
              height: '15px'
            }
          }}
        >
          <Image 
            src={mitem001} 
            minW={"700px"}
            width={"auto"}
            height={"100%"}
            alt="" 
          />
        </Box>
      }
      <Flex w={"100%"} justifyContent={"center"} mt={"200px"}>
        <Text color={"#333333"} fontSize={convertFontSize(20, 36)} fontWeight={700}>
          BBD 기반 TestOps 환경 구축
        </Text>
      </Flex>
      <Image 
        src={contents[1][screen]} 
        w={"100%"} 
        alt="" 
      />
      {screen !== "mobile" ?
        <Box 
          w={screen === "tablet" ? "90%" : "70%"} 
        >
          <Image 
            src={item002} 
            w={"100%"} 
            h={"auto"} 
            alt="" 
          />
        </Box>
      :
        <Box 
          display={"flex"} 
          w={"90%"} 
          h={"fit-content"}
          justifyContent={"start"} 
          overflowX={"scroll"}
          css={{
            '&::-webkit-scrollbar': {
              height: '10px'
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#A4A8AD',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
              height: '15px'
            }
          }}
        >
          <Image 
            src={mitem002} 
            minW={"700px"}
            w={"auto"} 
            h={"100%"} 
            alt="" 
          />
        </Box>
      }
      <Image 
        src={contents[2][screen]} 
        w={"100%"} 
        alt="" 
      />
    </Box>
  );
};

export default TestOps;